import { useEffect } from "react";
import { BestPriceGuaranteeModalContent } from "@apac/components/ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import { trackEvent } from "@hopper-b2b/api";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  BestPriceGuaranteeEventProductTypes,
  BestPriceGuaranteeEventProperties,
  BestPriceGuaranteeEvents,
} from "@hopper-b2b/types";
import { Dialog, DialogClose, DialogContent, DialogTrigger } from "@tenant/ui";
import clsx from "clsx";
import { ApacUiComponent } from "../../context";
import { useApacUiStyles } from "../../hooks";
import defaultStyles from "./styles.module.scss";

export const BestPriceGuaranteeCard = () => {
  const styles = useApacUiStyles(
    ApacUiComponent.BestPriceGuaranteeCard,
    defaultStyles
  );
  const [block, cn] = useModuleBEM(
    styles,
    ApacUiComponent.BestPriceGuaranteeCard
  );

  const { t } = useI18nContext();

  useEffect(() => {
    trackEvent({
      eventName: BestPriceGuaranteeEvents.viewed_best_price_guarantee,
      properties: {
        [BestPriceGuaranteeEventProperties.product]:
          BestPriceGuaranteeEventProductTypes.Flights,
      },
    });
  }, []);

  return (
    <Dialog>
      <div className={clsx(block)}>
        <div className={cn("best-price-guarantee-title")}>
          {t("apac.bestPriceGuarantee.title")}
        </div>
        <div className={cn("best-price-guarantee-subtitle")}>
          {t("apac.bestPriceGuarantee.subtitle")}
        </div>

        <DialogTrigger>
          <div className={cn("best-price-guarantee-cta")}>
            {t("apac.bestPriceGuarantee.learnMoreLabel")}
          </div>
        </DialogTrigger>
      </div>
      <DialogContent title={t("apac.bestPriceGuarantee.title")}>
        <BestPriceGuaranteeModalContent />
        <DialogClose className={cn("best-price-guarantee-close-modal")}>
          {t("close.button")}
        </DialogClose>
      </DialogContent>
    </Dialog>
  );
};
